<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit">
			<v-layout row wrap>
				<v-flex xs12 md6>
					<v-select ref="defaultFocusElement" v-model="value.department" :items="departmentsOrdered" :error-messages="departmentErrors" item-text="name" return-object label="Department" required>
						<template slot="label">Department<span class="required">*</span></template>
					</v-select>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.email" :error-messages="emailErrors" required>
						<template slot="label">Work Email<span class="required">*</span></template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.phone">
						<template slot="label">Work Phone</template>
					</v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Department</span>
						<span class="form-value">{{ value.department == null ? '-' : value.department.name }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Work Email</span>
						<span class="form-value">{{ $_getFormValue('email') }}</span>
					</div></v-flex
				>
				<v-flex xs12 md6
					><div class="form-group">
						<span class="form-label">Work Phone</span>
						<span class="form-value">{{ $_getFormValue('phone') }}</span>
					</div></v-flex
				>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { validationMixin } from 'vuelidate';
	import { required, email } from 'vuelidate/lib/validators';
	import formMixin from '@/mixins/employeeFormMixin';

	export default {
		mixins: [validationMixin, formMixin],
		validations: {
			value: {
				department: { required },
				email: { required, email }
			}
		},
		computed: {
			...mapGetters({
				departments: 'departments/departments'
			}),
            departmentsOrdered() {
				var departments = this.departments.slice(0);
				var sorted = departments.sort();
				sorted.unshift({ id: null, name: 'N/A' });
				return sorted;
			},
			departmentErrors() {
				const errors = [];
				if (!this.$v.value.department.$dirty) return errors;
				!this.$v.value.department.required && errors.push('Department is required.');
				return errors;
			},
			emailErrors() {
				const errors = [];
				if (!this.$v.value.email.$dirty) return errors;
				!this.$v.value.email.email && errors.push('Must be valid e-mail');
				!this.$v.value.email.required && errors.push('E-mail is required');
				return errors;
			}
		}
	};
</script>
